import React, { useRef, useState, Suspense } from 'react'
import { Canvas, useFrame } from 'react-three-fiber'
import makeStyles from "@material-ui/core/styles/makeStyles";
import {OrbitControls} from 'drei'
import { ChristmasTree, Gift } from './Home'

const useStyles = makeStyles(theme => ({
  background: {
    height: '100%',
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: -1,
    background: '#BAE9FF'
  }
}))




export default function Background(props) {
  let arr = Array.from(Array(1000).keys())

  const classes = useStyles()
  return (
    <div className={classes.background}>
      <Canvas colorManagement>
        <OrbitControls/>
        {/*<OrbitControls autoRotate/>*/}
        <ambientLight />
        <Suspense fallback={null}>
        <ChristmasTree position={[0,-3,0]} scale={[0.012,0.012,0.012]}/>
        </Suspense>
        <pointLight position={[0,-5,8]} instensity={.1}/>
        <pointLight  position={[0,-3, 10]} intensity={.2}/>
        {arr.map(() => {
          return <RainDrop position={[(Math.random()*20)-10, Math.random()*20-10, (Math.random()*20)-10]}/>
        })}
      </Canvas>
    </div>
  )
}

function RainDrop(props) {
  // This reference will give us direct access to the mesh
  const mesh = useRef()

  // Set up state for the hovered and active state
  const [hovered, setHover] = useState(false)
  const [active, setActive] = useState(false)

  // Rotate mesh every frame, this is outside of React without overhead
  useFrame(() => {
    mesh.current.position.y < -10 ? mesh.current.position.y = 10: mesh.current.position.y += -0.01
  })

  return (
    <mesh
      {...props}
      ref={mesh}
      scale={[1, 1, 1]}
      onClick={e => setActive(!active)}
      onPointerOver={e => setHover(true)}
      onPointerOut={e => setHover(false)}>
      <sphereBufferGeometry attach="geometry" args={[.025, 32, 4]} />
      <meshStandardMaterial attach="material" color={'white'}/>
    </mesh>
  )
}
